'use strict';

var AFM = require('./animate/FrameManager.js');

/**
 * @class
 * @classdesc This class contains static methods to get the viewport width and
 *            height. These can be called at any time without worrying about
 *            causing a relayout during mid-frame, and the returned sizes will
 *            exclude scrollbars and therefore match the width and height that
 *            media queries use.
 */
var Viewport = {};

var vpWidth, vpHeight, hasResized;

/**
 * @public
 */
Viewport.measure = function() {
	if (vpWidth === undefined || hasResized === true) {
		vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		vpHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		hasResized = false;
	}
}
AFM.on('read', Viewport.measure);
window.addEventListener('resize', function invalidateMeasurement() { hasResized = true; }, false);

/**
 * @public
 */
Viewport.getWidth = function() {
	return vpWidth;
}

/**
 * @public
 */
Viewport.getHeight = function() {
	return vpHeight;
}


module.exports = Viewport;